<template>
    <label class="form-label">
        {{ label }} <span v-if="required" class="text-danger">*</span>
    </label>
    <div class="input-group">
        <select
            :name="fieldName + '[code]'"
            class="form-control"
            :class="{ 'is-invalid': codeError || numberError }"
            v-model="selectedCode"
            style="max-width: 200px;"
            :required="required"
        >
            <option value="">{{ selectText }}</option>
            <option
                v-for="country in countries"
                :key="country.code"
                :value="country.code"
            >
                {{ country.name }} ({{ country.dial_code }})
            </option>
        </select>
        <input
            :name="fieldName + '[number]'"
            type="tel"
            class="form-control"
            :class="{ 'is-invalid': numberError }"
            v-model="phoneNumber"
            maxlength="15"
            :placeholder="placeholder"
            :required="required"
            @input="filterNumericInput"
        >
    </div>
    <div v-if="codeError" class="invalid-feedback d-block">
        {{ codeError }}
    </div>
    <div v-if="numberError" class="invalid-feedback d-block">
        {{ numberError }}
    </div>
</template>

<script>
export default {
    name: 'PhoneInputVertical',
    props: {
        fieldName: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        selectText: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default: ''
        },
        countries: {
            type: Array,
            required: true
        },
        oldCode: {
            type: String,
            default: ''
        },
        oldNumber: {
            type: String,
            default: ''
        },
        codeError: {
            type: String,
            default: ''
        },
        numberError: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedCode: this.oldCode,
            phoneNumber: this.oldNumber
        }
    },
    methods: {
        filterNumericInput(event) {
            const value = event.target.value;
            const filtered = value.replace(/[^\d]/g, '');
            if (value !== filtered) {
                this.phoneNumber = filtered;
            }
        }
    }
}
</script>
